import { Link } from "react-router-dom";
import { ArrowRight, ArrowRightLeft } from "lucide-react";
import { PRICES } from "../../data/content";

export const WELLPASS_END = "31.08.2027";
const START = new Date("2027-03-01T00:00:00+01:00");
export const wellpassSwitchActive = () => {
  if (new Date() >= START) return true;
  if (new URLSearchParams(window.location.search).has("wellpass-hinweis")) sessionStorage.setItem("wellpass-hinweis", "1");
  return sessionStorage.getItem("wellpass-hinweis") === "1";
};
const ask = `/?thema=frage&notiz=${encodeURIComponent("Ich trainiere mit Wellpass und möchte wissen, wie ich nach dem 31.08.2027 weiter bei euch trainieren kann.")}#anfrage`;

const WAYS = [
  ["Mit Epassi weiter – ohne Zusatzkosten", "Frag deine Personalabteilung nach Epassi. Als Flensburgs Epassi-Exklusiv-Studio bleibst du dann einfach bei uns – jeden Tag, alle Kursarten.", ["So funktioniert Epassi", "/firmenfitness"]],
  ["Mit eigenem Tarif weiter", `Ab ${PRICES[0].price} €/Monat, keine Aufnahmegebühr – auf Wunsch als Flex-Tarif ohne Laufzeit.`, ["Tarife ansehen", "/preise"]],
  ["Wir helfen beim Wechsel", "Sprich uns im Studio an oder schreib uns kurz – wir finden mit dir den passenden Weg.", ["Frage stellen", ask]],
];

export const WellpassSwitch = ({ compact = false, dark = false, className = "" }) => {
  if (!wellpassSwitchActive()) return null;
  if (compact) return (
    <p data-testid="wellpass-switch-compact" className={`text-xs leading-relaxed ${dark ? "text-white/80" : "text-[#3A3A3E]"} ${className}`}>
      <ArrowRightLeft size={12} className="inline mr-1.5 text-[#BA00C5]" /><strong>Wellpass endet bei uns am {WELLPASS_END}.</strong> Weiter geht es mit Epassi (ohne Zusatzkosten) oder einem eigenen Tarif ab {PRICES[0].price} €. <Link to="/firmenfitness#wellpass-wechsel" data-testid="wellpass-switch-compact-link" className="font-semibold underline underline-offset-2">So wechselst du</Link>
    </p>
  );
  return (
    <section id="wellpass-wechsel" data-testid="wellpass-switch" className={`scroll-mt-24 rounded-3xl border-2 border-[#F2C77D] bg-[#FFF7E8] p-5 md:p-7 ${className}`}>
      <p className="inline-flex items-center gap-2 font-head text-xs font-bold uppercase tracking-wide text-[#92400E]"><ArrowRightLeft size={14} />Für Wellpass-Nutzer</p>
      <h2 className="mt-2 font-head text-xl md:text-2xl font-bold">Wellpass endet bei uns am {WELLPASS_END} – so trainierst du weiter</h2>
      <ol className="mt-5 grid md:grid-cols-3 gap-3">
        {WAYS.map(([t, d, [l, href]], i) => (
          <li key={t} data-testid={`wellpass-switch-way-${i}`} className="rounded-2xl bg-white border border-[#F2C77D]/60 p-4 flex flex-col">
            <span className="w-7 h-7 rounded-full bg-[#161616] text-white text-xs font-bold flex items-center justify-center">{i + 1}</span>
            <p className="mt-3 font-head font-bold">{t}</p>
            <p className="mt-1 text-sm muted leading-relaxed flex-1">{d}</p>
            <Link to={href} data-testid={`wellpass-switch-link-${i}`} className="tap mt-3 inline-flex items-center gap-1.5 text-sm font-semibold hover:text-[#8A0093]">{l} <ArrowRight size={14} /></Link>
          </li>
        ))}
      </ol>
    </section>
  );
};
